export default "__VITE_ASSET__DfJsoZSs__"